// extracted by mini-css-extract-plugin
export default {"main":"Features_main__djOKd","content":"Features_content__PZy1J","heading":"Features_heading__8dZbd","features":"Features_features__Z0ymW","card":"Features_card__UA2E+"};